// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import type { Media, Crop } from '../../types'
import logo from '../images/tm-promo-logo.png'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import ImagePreview from '../../ImagePreview'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 580px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: -1px 3px 10px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
`

const Heading: StyledComponent<Object, any, any> = styled.div`
  margin-bottom: 15px;
`

const InnerHeading: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-direction: row;
`

const HeadingBadge: StyledComponent<Object, any, any> = styled.div`
  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
  display: inline-block;
  color: #fff;
  line-height: 1;
  padding: 4px 8px;
  background-color: #999;
  border-radius: 2px;
  font-size: 11px;
`

const HeadingTitle: StyledComponent<Object, any, any> = styled.div`
  font-family: Helvetica, sans-serif;
  color: #686868;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
`

const Section: StyledComponent<Object, any, any> = styled.div`
  border: #ebebeb 1px solid;
`

const InnerSection: StyledComponent<Object, any, any> = styled.div`
  padding: 14px;
  padding-left: 16px;
`

const SectionDescription: StyledComponent<Object, any, any> = styled.div`
  margin-bottom: 10px;
  font-size: 14px;
  color: #6f7173;
`

const SectionURL: StyledComponent<Object, any, any> = styled.div`
  color: #dd7f6a;
  font-size: 14px;
  cursor: pointer;
`
const ClearFix: StyledComponent<Object, any, any> = styled.div`
  clear: both;
  &:after {
    display: table;
    content: '';
    clear: both;
  }
`

type Props = {|
  title: string,
  description: string,
  image: ?Media,
  imageCrop: ?Crop,
  logoImage: ?Media,
  logoImageCrop: ?Crop,
  url: string
|}

export default function TmLenta(props: Props) {
  const { title, logoImage, logoImageCrop, description, image, imageCrop, url } = props

  return (
    <Wrapper>
      <Heading>
        <InnerHeading>
          <div style={{ marginRight: 15 }}>
            <div>
              <ImagePreview
                width={40}
                height={40}
                imageSrc={(logoImage && logoImage.src) || logo}
                size={{
                  width: (logoImage && logoImage.width) || 40,
                  height: (logoImage && logoImage.height) || 40
                }}
                crop={logoImageCrop}
                float
                isRounded
              />
            </div>
          </div>
          <div>
            <HeadingTitle>{title}</HeadingTitle>
            <HeadingBadge>Реклама</HeadingBadge>
          </div>
        </InnerHeading>
      </Heading>

      <Section>
        <InnerSection>
          <SectionDescription>{description}</SectionDescription>
          <SectionURL>{url}</SectionURL>
        </InnerSection>
        <ClearFix>
          <OptionalResponsibleImage
            float
            image={image}
            imageCrop={imageCrop}
            width={538}
            ratio={1.91}
          />
        </ClearFix>
      </Section>
    </Wrapper>
  )
}
